import { Flex, Text } from '@chakra-ui/react';

const RangeSelect = ({ period, setPeriod }) => {
  const styleFilterActive = {
    color: '#099BFF',
    borderBottom: '1px solid #099BFF',
  };

  const filter = async (type) => {
    setPeriod(type);
  };
  return (
    <Flex
      gap="24px"
      zIndex="1"
      position="absolute"
      borderBottom="1px solid rgba(255, 255, 255, 0.10)"
      right="26px"
      mt="0px"
      pb="0px"
    >
      <Text
        variant="title"
        onClick={() => filter('week')}
        style={period === 'week' ? styleFilterActive : null}
        pb="5px"
        mb="-1px"
        cursor="pointer"
      >
        Week
      </Text>

      <Text
        variant="title"
        onClick={() => filter('month')}
        style={period === 'month' ? styleFilterActive : null}
        pb="5px"
        mb="-1px"
        cursor="pointer"
      >
        Month
      </Text>

      <Text
        variant="title"
        onClick={() => filter('year')}
        style={period === 'year' ? styleFilterActive : null}
        pb="5px"
        mb="-1px"
        cursor="pointer"
      >
        Year
      </Text>
    </Flex>
  );
};

export default RangeSelect;
